var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotiBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19C8.45849 20.7252 10.0755 22 12 22C13.9245 22 15.5415 20.7252 16 19M4.47513 9.49999C4.47513 5.35786 7.84413 1.99999 12 1.99999C16.1559 1.99999 19.5249 5.35786 19.5249 9.49999C19.525 10.5718 19.5873 11.5793 20.2144 12.5029C20.6932 13.1995 21.3394 13.9129 21.4701 14.7696C21.6827 16.1636 20.732 17.1312 19.5679 17.6134C15.1052 19.4622 8.89481 19.4622 4.43205 17.6134C3.268 17.1312 2.31727 16.1636 2.52992 14.7696C2.66061 13.9129 3.30684 13.1995 3.78561 12.5029C4.41272 11.5793 4.47503 10.5718 4.47513 9.49999Z",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiBell);
export default __webpack_public_path__ + "static/media/noti-bell.d7410763989ee90621b6dc1968d5e210.svg";
export { ForwardRef as ReactComponent };